/**
 * Do not edit directly
 * Generated on Fri, 03 Feb 2023 17:25:01 GMT
 */

export const blueUltramarine800 = '#0029c5';
export const blueUltramarine500 = '#0948eb';
export const blueUltramarine400 = '#3e64f8';
export const blueUltramarine370 = '#5081ff';
export const blueUltramarine350 = '#376fff';
export const blueUltramarine300 = '#6281ff';
export const blueUltramarine200 = '#6a94ff';
export const blueUltramarine180 = '#83a6ff';
export const blueUltramarine150 = '#9db9ff';
export const blueUltramarine100 = '#b6cbff';
export const blueUltramarine070 = '#c0d2ff';
export const blueUltramarine060 = '#cbdaff';
export const blueUltramarine055 = '#d5e1ff';
export const blueUltramarine050 = '#e0e9ff';
export const blueUltramarine040 = '#eaf0ff';
export const blueUltramarine030 = '#f5f8ff';
export const blueGrey = '#859BCC';
export const white = '#ffffff';
export const black = '#000000';
export const nearBlack = '#0D1832';
export const blueBlack950 = '#111318';
export const blueBlack700 = '#222630';
export const blueBlack650 = '#333948';
export const blueBlack640 = '#546078';
export const blueBlack630 = '#6a728a';
export const blueBlack500 = '#657390';
export const blueBlack400 = '#7686a8';
export const neutralGrey = '#949AAB';
export const greyLight600 = '#e2e8f2';
export const greyLight500 = '#eaeff6';
export const greyLight400 = '#FAFAFA';
export const greyLight350 = '#F0EFEF';
export const greyLight300 = '#f3f5f9';
export const greyLight200 = '#f7f8fb';
export const greyLight100 = '#fbfcfd';
export const green400 = '#4caf50';
export const green300 = '#64c668';
export const green200 = '#88d18b';
export const green150 = '#80CBC4';
export const green100 = '#c0dbc1';
export const green050 = '#edfbee';
export const yellowGreen100 = '#CBFF38';
export const green40020 = '#64c66833';
export const teal200 = '#99C8FF';
export const yellow500 = '#ffde38';
export const yellow600 = '#d5a701';
export const yellowOrange100 = '#FFE7AB';
export const yellowOrange300 = '#FFB803';
export const orange100 = '#FF9A03';
export const orange700 = '#ff8a1e';
export const red400 = '#ff505f';
export const red600 = '#ec0f19';
export const red100 = '#ff979c';
export const red050 = '#ffccd0';
export const red020 = '#ffe8ea';
export const red010 = '#ffeeef';
export const red40030 = '#ff505f4d';
export const yellowOrange30085 = 'rgba(255,138,30,.85)';
export const yellow100 = '#fef4c4';
export const yellow040 = '#fffdf1';
export const yellow050 = '#fffdf1';
export const ochre700 = '#e9a614';
export const ochre500 = '#ecba70';
export const ochre100 = '#efdbbe';
export const ochre050 = '#fff8ed';
export const blue70008 = '#0b79d014';
export const blue050 = '#EBF7FD';
export const blue100 = '#c9e8ff';
export const blue200 = '#69bfff';
export const blue500 = '#2196f3';
export const blue700 = '#0b79d0';
export const blue800 = '#00579c';
export const blue900 = '#071e61';
export const purple050 = '#efecfb';
export const purple100 = '#dfd9ff';
export const purple200 = '#ac9cff';
export const purple500 = '#7b61ff';
export const purple700 = '#702ee6';
export const magenta800 = '#BA68C8';
export const magenta700 = '#b62ee6';
export const magenta300 = '#df86ff';
export const magenta200 = '#ecb9ff';
export const magenta100 = '#E1BEE7';
export const magenta050 = '#f7e3ff';

export const greyLight650 = '#cdd4de';
export const greyLight700 = '#919ba9';
export const greyLight750 = '#717b8a';
export const greyLight800 = '#3f4d62';
export const brandDark = '#0948eb';
export const brandMid = '#3e64f8';
export const brandLight = '#6281ff';
export const foregroundDefault = '#333948';
export const foregroundMuted = '#546078';
export const foregroundSubtle = '#6a728a';
export const backgroundDefault = '#f3f5f9';
export const backgroundSubtle = '#fbfcfd';
export const backgroundCard = '#ffffff';
export const severityAdvanced = '#ec0f19';
export const severitySevere = '#ff505f';
export const severityModerateSevere = '#ff8a1e';
export const severityModerate = '#ffb803';
export const severityConcern = '#ffde38';
export const severityOk = '#4caf50';
export const confidenceOpacityVeryHigh = '1';
export const confidenceOpacityHigh = '0.85';
export const confidenceOpacityMed = '0.65';
export const confidenceOpacityLow = '0.4';
export const confidenceOpacityVeryLow = '0.2';
export const cariesConfidenceValueVeryHigh = `rgba(255,80,95,${confidenceOpacityVeryHigh})`;
export const cariesConfidenceValueHigh = `rgba(255,80,95,${confidenceOpacityHigh})`;
export const cariesConfidenceValueMed = `rgba(255,80,95,${confidenceOpacityMed})`;
export const cariesConfidenceValueLow = `rgba(255,80,95,${confidenceOpacityLow})`;
export const cariesConfidenceValueVeryLow = `rgba(255,80,95,${confidenceOpacityVeryLow})`;
export const toothAnatomyEnamel = 'rgba(255, 252, 212, 0.15)';
export const toothAnatomyPulp = 'rgba(35, 40, 146, 0.2)';
export const toothAnatomyPulpGray = 'rgba(22, 37, 48, 0.4)';
export const toothAnatomyScreenBackdrop = 'rgba(146, 161, 194, .7)';
export const legacyRed = '#ec0f19';
export const legacyGreen = '#4caf50';
export const legacyYellow = '#ffde38';
export const legacyOrange = '#ff8a1e';
export const legacyWhite = '#ffffff';
export const legacyPurple = '#7b61ff';
export const legacyRoottiphover = '#df86ff';
export const legacyCej = '#2196f3';
export const legacyAbd = '#2196f3';
export const legacyCarieshighconfidence = '#ff505f';
export const legacyCariesmediumconfidence = '#ff8a1e';
export const legacyCarieslowconfidence = '#ffde38';
export const legacyAgree = '#ff505f';
export const legacyMonitor = '#ff8a1e';
export const legacyHover = '#c9e8ff';
export const legacyPureWhite = '#ffffff';
export const legacyOffWhite = '#fbfcfd';
export const legacyDimWhite = '#FAFAFA';
export const legacyLightWhite = '#f3f5f9';
export const legacyLightWhite2 = '#f7f8fb';
export const legacyPureBlack = '#000000';
export const legacyMidBlack = '#111318';
export const legacyDarkerGrey = '#111318';
export const legacyVeryDarkGrey = '#222630';
export const legacyDarkGrey = '#333948';
export const legacyMidGrey = '#6a728a';
export const legacyMidGrey2 = '#657390';
export const legacyMidLighterGrey = '#f3f5f9';
export const legacyMidLightGrey = '#eaeff6';
export const legacyVeryLightGrey = '#FAFAFA';
export const legacyPrimary = '#0948eb';
export const legacyPrimaryHighlight = '#EBF7FD';
export const legacySecondary = '#702ee6';
export const legacyLightPurple = '#efecfb';
export const legacyLightGrey = '#cdd4de';
export const legacyQuote = '#919ba9';
export const legacyCaption = '#717b8a';
export const legacyHeader = '#3f4d62';
export const legacyDarkBlue = '#071e61';
export const legacyMidBlue = '#071e61';
export const legacyBlue = '#0b79d0';
export const legacyLightSkyBlue = '#0b79d014';
export const legacyDarkYellow = '#ffb803';
export const legacyMidGreen = '#4caf50';
export const legacyViolet = '#7b61ff';
export const legacyGreyBorder = '#cdd4de';
export const legacyInsipientMarks = '#919ba9';
export const legacyBlueIcon = '#0948eb';
export const legacyHeaderBgColor = '#0948eb';
export const fontFamiliesProximaNova = 'proxima-nova, sans-serif';
export const fontFamiliesNeueHaasGroteskDisplayPro =
  'Neue Haas Grotesk Display Pro';
export const lineHeights0 = '1.375em';
export const lineHeights1 = '1em';
export const lineHeights2 = '1.125em';
export const lineHeights3 = '.875em';
export const lineHeights4 = '.625em';
export const lineHeights5 = '.75em';
export const lineHeights6 = '1.25em';
export const fontWeightsProximaNovaLight = '400';
export const fontWeightsProximaNovaMedium = '600';
export const fontWeightsProximaNovaRegular = '500';
export const fontWeightsProximaNovaBold = '700';
export const fontWeightsNeueHaasGroteskDisplayProBold = '800';
export const fontWeightsNeueHaasGroteskDisplayProRegular = '500';
export const fontWeightsNeueHaasGroteskDisplayProMedium = '600';
export const fontSize0 = '.6875em';
export const fontSize1 = '.75em';
export const fontSize2 = '.875em';
export const fontSize3 = '1em';
export const fontSize4 = '1.125em';
export const fontSize5 = '1.25em';
export const fontSize6 = '1.625em';
export const fontSize7 = '2.125em';
export const fontSize8 = '2.5em';
export const fontSize9 = '2.265em';
export const fontSize10 = '3.25em';
export const letterSpacing0 = '0.4px';
export const letterSpacing1 = '0.15px';
export const letterSpacing2 = '-.02em';
export const letterSpacing3 = '0';
export const letterSpacing4 = '-.03em';
export const letterSpacing5 = '-.05em';
export const buttonMediumFontFamily = 'proxima-nova, sans-serif';
export const buttonMediumFontWeight = 'normal';
export const buttonMediumLineHeight = '1.375em';
export const buttonMediumFontSize = '1.125em';
export const buttonMediumLetterSpacing = '0.4px';
export const labelSmallFontFamily = 'proxima-nova, sans-serif';
export const labelSmallFontWeight = 'normal';
export const labelSmallLineHeight = '1em';
export const labelSmallFontSize = '1em';
export const labelSmallLetterSpacing = '0.15px';
export const headingMediumFontFamily = 'Neue Haas Grotesk Display Pro';
export const headingMediumFontWeight = 'normal';
export const headingMediumLineHeight = '1.125em';
export const headingMediumFontSize = '2.125em';
export const headingMediumLetterSpacing = '-.02em';
export const headingSmallFontFamily = 'Neue Haas Grotesk Display Pro';
export const headingSmallFontWeight = 'normal';
export const headingSmallLineHeight = '1em';
export const headingSmallFontSize = '1.625em';
export const headingSmallLetterSpacing = '-.01em';
export const headingExtrasmallFontFamily = 'Neue Haas Grotesk Display Pro';
export const headingExtrasmallFontWeight = '600';
export const headingExtrasmallLineHeight = '1.125em';
export const headingExtrasmallFontSize = '1.125em';
export const headingExtrasmallLetterSpacing = '0';
export const bodySmallFontFamily = 'proxima-nova, sans-serif';
export const bodySmallFontWeight = 'normal';
export const bodySmallLineHeight = '1em';
export const bodySmallFontSize = '1em';
export const bodySmallLetterSpacing = '-0.025em';
export const bodyExtrasmallFontFamily = 'proxima-nova, sans-serif';
export const bodyExtrasmallFontWeight = 'normal';
export const bodyExtrasmallLineHeight = '.875em';
export const bodyExtrasmallFontSize = '.875em';
export const bodyExtrasmallLetterSpacing = '0';
export const overlineFontFamily = 'proxima-nova, sans-serif';
export const overlineFontWeight = 'Bold';
export const overlineLineHeight = '1em';
export const overlineFontSize = '.875em';
export const overlineLetterSpacing = '0.15px';
export const labelSmallStrongFontFamily = 'proxima-nova, sans-serif';
export const labelSmallStrongFontWeight = '600';
export const labelSmallStrongLineHeight = '1em';
export const labelSmallStrongFontSize = '1em';
export const labelSmallStrongLetterSpacing = '0.15px';
export const labelExtrasmallFontFamily = 'proxima-nova, sans-serif';
export const labelExtrasmallFontWeight = 'normal';
export const labelExtrasmallLineHeight = '1em';
export const labelExtrasmallFontSize = '.6875em';
export const labelExtrasmallLetterSpacing = '0.15px';
export const headingLargeFontFamily = 'Neue Haas Grotesk Display Pro';
export const headingLargeFontWeight = '75 Bold';
export const headingLargeLineHeight = '1em';
export const headingLargeFontSize = '2.5em';
export const headingLargeLetterSpacing = '-.03em';
export const typographyBodyFontFamily = 'proxima-nova, sans-serif';
export const typographyBodyFontWeight = '55 Roman';
export const typographyBodyLineHeight = '110%';
export const typographyBodyFontSize = '1em';
export const typographyBodyLetterSpacing = '0px';
export const typographyH1BoldFontFamily = 'Neue Haas Grotesk Display Pro';
export const typographyH1BoldFontWeight = '75 Bold';
export const typographyH1BoldLineHeight = '110%';
export const typographyH1BoldFontSize = '3.25em';
export const typographyH1BoldLetterSpacing = '-.03em';
export const typographyH1RegularFontFamily = 'Neue Haas Grotesk Display Pro';
export const typographyH1RegularFontWeight = '65 Medium';
export const typographyH1RegularLineHeight = '110%';
export const typographyH1RegularFontSize = '3.25em';
export const typographyH1RegularLetterSpacing = '-.03em';
export const typographyH2BoldFontFamily = 'Neue Haas Grotesk Display Pro';
export const typographyH2BoldFontWeight = '75 Bold';
export const typographyH2BoldLineHeight = '110%';
export const typographyH2BoldFontSize = '2.5em';
export const typographyH2BoldLetterSpacing = '-.03em';
export const typographyH2RegularFontFamily = 'Neue Haas Grotesk Display Pro';
export const typographyH2RegularFontWeight = '65 Medium';
export const typographyH2RegularLineHeight = '110%';
export const typographyH2RegularFontSize = '2.5em';
export const typographyH2RegularLetterSpacing = '-.03em';
export const textDecorationNone = 'none';
export const borderWidth = '2px';
export const borderColor = '#cdd4de';
export const borderStyle = 'solid';
export const transparent = 'rgba(0,0,0,0)';
export const textPrimary = '#E0E6ED';
